import React, { CSSProperties, FC } from "react";
import { useTranslation } from "react-i18next";

interface IZedIcon {
  width: number;
  height: number;
  onClick?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  style?: CSSProperties;
  className?: string;
  isColor?: boolean;
}

export const ZedIcon: FC<IZedIcon> = ({
  width,
  height,
  onClick,
  style,
  className,
  isColor = true,
}) => {
  const { t } = useTranslation();
  return isColor ? (
    <svg
      style={{ ...style, color: "white" }}
      onClick={(e) => {
        if (onClick) onClick(e);
      }}
      className={className}
      width={width}
      height={height}
      xlinkTitle={t("button.zedPortal")}
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 703.79 299.55"
    >
      <defs></defs>
      <path
        className="cls-2"
        style={{ fill: "#2d3e50" }}
        d="M176.76,235.3c4.98,5.25,7.47,11.41,7.47,18.49,0,7.61-2.49,13.96-7.47,19.07-4.98,5.11-11.28,7.67-18.87,7.67H32.05c-5.25-.26-9.83-1.64-13.76-4.13-3.93-2.49-6.95-5.7-9.05-9.64-2.1-3.93-3.14-8.26-3.14-12.98s1.3-9.44,3.93-14.16l.39-.39L109.12,82.33H31.26c-7.08,0-13.24-2.49-18.49-7.47-5.25-4.98-7.86-11.27-7.86-18.88s2.62-13.63,7.86-18.87,11.41-7.87,18.49-7.87h125.83c4.98,.26,9.5,1.71,13.57,4.33,4.06,2.63,7.21,5.97,9.44,10.03,2.23,4.07,3.35,8.52,3.35,13.37s-1.45,9.63-4.33,14.35L80.81,227.43h77.08c7.6,0,13.89,2.63,18.87,7.86Z"
      />
      <path
        className="cls-2"
        style={{ fill: "#2d3e50" }}
        d="M297.94,90.44c12.58,0,24.64,2.63,36.18,7.86,11.53,5.25,21.69,12.26,30.47,21.04,8.78,8.78,15.79,18.87,21.04,30.28,5.24,11.41,7.87,23.4,7.87,35.98,0,6.82-2.56,12.85-7.67,18.09-5.11,5.25-11.47,7.73-19.07,7.47h-104.6c8.65,12.33,20.58,18.48,35.79,18.48,4.19,0,7.73-.39,10.62-1.18,2.88-.79,5.44-1.7,7.67-2.76,2.23-1.04,4.45-1.96,6.69-2.75,2.22-.79,4.78-1.18,7.67-1.18,5.51,.26,10.29,1.83,14.35,4.71,4.06,2.89,7.08,6.49,9.05,10.82,1.96,4.32,2.62,8.98,1.96,13.96-.66,4.98-2.95,9.57-6.88,13.76-7.08,5.77-14.94,9.77-23.6,12-8.65,2.23-17.83,3.48-27.52,3.73-12.58,.52-24.65-1.77-36.18-6.88-11.54-5.11-21.69-12.06-30.47-20.84-8.79-8.78-15.73-19.07-20.84-30.87-5.11-11.8-7.67-23.99-7.67-36.57s2.56-24.25,7.67-35.79c5.11-11.53,11.99-21.69,20.65-30.47,8.65-8.78,18.74-15.79,30.28-21.04,11.53-5.24,23.72-7.86,36.57-7.86Zm35.78,69.21c-4.46-5.5-9.7-9.89-15.73-13.17-6.03-3.28-12.72-4.92-20.05-4.92s-14.36,1.64-20.25,4.92c-5.9,3.28-11.08,7.67-15.53,13.17h71.57Z"
      />
      <path
        className="cls-2"
        style={{ fill: "#2d3e50" }}
        d="M577.15,30.03c6.81,0,12.78,2.43,17.89,7.27,5.11,4.85,7.67,11.08,7.67,18.68V185.36c0,12.85-2.55,25.04-7.67,36.57-5.11,11.54-12.06,21.63-20.84,30.28-8.78,8.65-18.94,15.53-30.48,20.64-11.53,5.11-23.59,7.67-36.17,7.67s-24.64-2.49-36.18-7.47c-11.54-4.98-21.7-11.79-30.48-20.45-8.78-8.65-15.8-18.74-21.03-30.28-5.25-11.54-7.87-23.86-7.87-36.97s2.56-25.03,7.67-36.57c5.11-11.54,12.05-21.63,20.84-30.28,8.78-8.65,18.94-15.53,30.48-20.65,11.54-5.11,23.72-7.67,36.57-7.67,15.73,0,30.28,3.54,43.65,10.62V55.59c0-3.41,.72-6.69,2.16-9.83,1.44-3.15,3.35-5.9,5.7-8.26,2.36-2.36,5.11-4.19,8.26-5.51,3.14-1.31,6.42-1.97,9.83-1.97Zm-69.6,111.29c-6.03,0-11.74,1.18-17.11,3.54-5.38,2.36-10.1,5.57-14.16,9.63-4.07,4.07-7.27,8.78-9.63,14.16-2.36,5.38-3.54,10.94-3.54,16.71s1.18,11.74,3.54,17.1c2.36,5.38,5.57,10.03,9.63,13.96,4.06,3.94,8.78,7.08,14.16,9.44,5.37,2.36,11.07,3.54,17.11,3.54s11.27-1.18,16.51-3.54c5.24-2.36,9.89-5.56,13.96-9.63,4.06-4.06,7.27-8.72,9.63-13.96,2.36-5.24,3.54-10.88,3.54-16.91s-1.18-12.12-3.54-17.5c-2.36-5.38-5.57-10.03-9.63-13.96-4.07-3.94-8.72-7.01-13.96-9.25-5.25-2.22-10.75-3.34-16.51-3.34Z"
      />
      <g>
        <path
          style={{ fill: "#00aeef" }}
          className="cls-1"
          d="M676.22,269.98c0,7.28-5.71,13.17-12.74,13.17h-7.44c-7.04,0-12.73-5.89-12.73-13.17v-50.5c0-7.27,5.7-13.17,12.73-13.17h7.44c7.03,0,12.74,5.9,12.74,13.17v50.5Z"
        />
        <path
          style={{ fill: "#00aeef" }}
          className="cls-1"
          d="M684.87,228.55c7.28,0,13.18,5.7,13.18,12.74v7.43c0,7.04-5.9,12.74-13.18,12.74h-50.49c-7.28,0-13.18-5.7-13.18-12.74v-7.43c0-7.04,5.9-12.74,13.18-12.74h50.49Z"
        />
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style, color: "white" }}
      onClick={(e) => {
        if (onClick) onClick(e);
      }}
      className={className}
      width={width}
      height={height}
      xlinkTitle={t("button.zedPortal")}
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 703.79 299.55"
    >
      <defs></defs>
      <path
        className="cls-1"
        style={{ fill: "#FFFFFF" }}
        d="M176.76,235.3c4.98,5.25,7.47,11.41,7.47,18.49,0,7.61-2.49,13.96-7.47,19.07-4.98,5.11-11.28,7.67-18.87,7.67H32.05c-5.25-.26-9.83-1.64-13.76-4.13-3.93-2.49-6.95-5.7-9.05-9.64-2.1-3.93-3.14-8.26-3.14-12.98s1.3-9.44,3.93-14.16l.39-.39L109.12,82.33H31.26c-7.08,0-13.24-2.49-18.49-7.47-5.25-4.98-7.86-11.27-7.86-18.88s2.62-13.63,7.86-18.87,11.41-7.87,18.49-7.87h125.83c4.98,.26,9.5,1.71,13.57,4.33,4.06,2.63,7.21,5.97,9.44,10.03,2.23,4.07,3.35,8.52,3.35,13.37s-1.45,9.63-4.33,14.35L80.81,227.43h77.08c7.6,0,13.89,2.63,18.87,7.86Z"
      />
      <path
        className="cls-1"
        style={{ fill: "#FFFFFF" }}
        d="M297.94,90.44c12.58,0,24.64,2.63,36.18,7.86,11.53,5.25,21.69,12.26,30.47,21.04,8.78,8.78,15.79,18.87,21.04,30.28,5.24,11.41,7.87,23.4,7.87,35.98,0,6.82-2.56,12.85-7.67,18.09-5.11,5.25-11.47,7.73-19.07,7.47h-104.6c8.65,12.33,20.58,18.48,35.79,18.48,4.19,0,7.73-.39,10.62-1.18,2.88-.79,5.44-1.7,7.67-2.76,2.23-1.04,4.45-1.96,6.69-2.75,2.22-.79,4.78-1.18,7.67-1.18,5.51,.26,10.29,1.83,14.35,4.71,4.06,2.89,7.08,6.49,9.05,10.82,1.96,4.32,2.62,8.98,1.96,13.96-.66,4.98-2.95,9.57-6.88,13.76-7.08,5.77-14.94,9.77-23.6,12-8.65,2.23-17.83,3.48-27.52,3.73-12.58,.52-24.65-1.77-36.18-6.88-11.54-5.11-21.69-12.06-30.47-20.84-8.79-8.78-15.73-19.07-20.84-30.87-5.11-11.8-7.67-23.99-7.67-36.57s2.56-24.25,7.67-35.79c5.11-11.53,11.99-21.69,20.65-30.47,8.65-8.78,18.74-15.79,30.28-21.04,11.53-5.24,23.72-7.86,36.57-7.86Zm35.78,69.21c-4.46-5.5-9.7-9.89-15.73-13.17-6.03-3.28-12.72-4.92-20.05-4.92s-14.36,1.64-20.25,4.92c-5.9,3.28-11.08,7.67-15.53,13.17h71.57Z"
      />
      <path
        className="cls-1"
        style={{ fill: "#FFFFFF" }}
        d="M577.15,30.03c6.81,0,12.78,2.43,17.89,7.27,5.11,4.85,7.67,11.08,7.67,18.68V185.36c0,12.85-2.55,25.04-7.67,36.57-5.11,11.54-12.06,21.63-20.84,30.28-8.78,8.65-18.94,15.53-30.48,20.64-11.53,5.11-23.59,7.67-36.17,7.67s-24.64-2.49-36.18-7.47c-11.54-4.98-21.7-11.79-30.48-20.45-8.78-8.65-15.8-18.74-21.03-30.28-5.25-11.54-7.87-23.86-7.87-36.97s2.56-25.03,7.67-36.57c5.11-11.54,12.05-21.63,20.84-30.28,8.78-8.65,18.94-15.53,30.48-20.65,11.54-5.11,23.72-7.67,36.57-7.67,15.73,0,30.28,3.54,43.65,10.62V55.59c0-3.41,.72-6.69,2.16-9.83,1.44-3.15,3.35-5.9,5.7-8.26,2.36-2.36,5.11-4.19,8.26-5.51,3.14-1.31,6.42-1.97,9.83-1.97Zm-69.6,111.29c-6.03,0-11.74,1.18-17.11,3.54-5.38,2.36-10.1,5.57-14.16,9.63-4.07,4.07-7.27,8.78-9.63,14.16-2.36,5.38-3.54,10.94-3.54,16.71s1.18,11.74,3.54,17.1c2.36,5.38,5.57,10.03,9.63,13.96,4.06,3.94,8.78,7.08,14.16,9.44,5.37,2.36,11.07,3.54,17.11,3.54s11.27-1.18,16.51-3.54c5.24-2.36,9.89-5.56,13.96-9.63,4.06-4.06,7.27-8.72,9.63-13.96,2.36-5.24,3.54-10.88,3.54-16.91s-1.18-12.12-3.54-17.5c-2.36-5.38-5.57-10.03-9.63-13.96-4.07-3.94-8.72-7.01-13.96-9.25-5.25-2.22-10.75-3.34-16.51-3.34Z"
      />
      <g>
        <path
          className="cls-1"
          style={{ fill: "#FFFFFF" }}
          d="M676.22,269.98c0,7.28-5.71,13.17-12.74,13.17h-7.44c-7.04,0-12.73-5.89-12.73-13.17v-50.5c0-7.27,5.7-13.17,12.73-13.17h7.44c7.03,0,12.74,5.9,12.74,13.17v50.5Z"
        />
        <path
          className="cls-1"
          style={{ fill: "#FFFFFF" }}
          d="M684.87,228.55c7.28,0,13.18,5.7,13.18,12.74v7.43c0,7.04-5.9,12.74-13.18,12.74h-50.49c-7.28,0-13.18-5.7-13.18-12.74v-7.43c0-7.04,5.9-12.74,13.18-12.74h50.49Z"
        />
      </g>
    </svg>
  );
};
